import { ChampionshipRowDto } from 'modules/tournaments/domain/interfaces/responce-dto';
import { TeamGroupStatisticsRow } from 'modules/tournaments/domain/interfaces/team-group-statistics';

export function teamStatisticsDtoDataMapper(statisticsDto: ChampionshipRowDto): TeamGroupStatisticsRow {
  return {
    position: statisticsDto.position ?? 99,
    teamId: statisticsDto.team.id,
    gamesPlayed: statisticsDto.gamesPlayed ?? 0,
    gamesWon: statisticsDto.gamesWon ?? 0,
    gamesDraw: statisticsDto.gamesDraw ?? 0,
    gamesLost: statisticsDto.gamesLost ?? 0,
    goalsWon: statisticsDto.goalsWon ?? 0,
    goalsLost: statisticsDto.goalsLost ?? 0,
    score: statisticsDto.championshipScore ?? 0,
  };
}
